import React from "react";
import Modal from "react-modal";

const LogsModal = ({ modalContent, closeModal }) => {
  const getParent = () => {
    return document.querySelector("body");
  };
  return (
    <Modal
      closeTimeoutMS={500}
      ariaHideApp={false}
      parentSelector={getParent}
      className="handsonTable__modal"
      isOpen={!!modalContent}
      onRequestClose={() => closeModal()}
      overlayClassName="handsonTable__modal--overlay"
      contentLabel="Messages Modal"
    >
      <div
        className="handsonTable__modal--content"
        dangerouslySetInnerHTML={{ __html: modalContent }}
      />
    </Modal>
  );
};

export default LogsModal;
